module.exports = __webpack_public_path__ + "img/hakuna_h_item.097d1b36.jpg";